<template>
  <div>
    <v-toolbar flat color="white" class="pt-3">
        <v-btn v-if="organisationDetail.isActive" round color="light-green" class="white--text" @click="changeActiveStatus()">Active</v-btn>
      <v-btn v-else round color="red" class="white--text" @click="changeActiveStatus()">Inactive</v-btn>
      <h2 class="dark-grey--text px-2">{{organisationDetail.name}}</h2>
      <v-spacer></v-spacer>
      <v-btn
        round
        color="primary"
        v-if="displayContents('info')"
        @click="saveInfoChanges"
      >Save Info Changes</v-btn>
      <v-btn
        round
        color="primary"
        v-if="displayContents('modules')"
        @click="saveModuleChanges"
      >Save Module Changes</v-btn>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('info')">
      <v-flex>
        <v-card flat color="white">
          <!-- <h2>Organisation Info</h2> -->
          <v-card-text>
            <v-layout justify-center wrap>
              <v-flex xs6>
                <v-layout wrap>
                  <v-flex xs3 mx-1>
                <v-text-field label="Organisation Name" v-model="organisationDetail.name"></v-text-field>
                <v-text-field label="Order Page URL" v-model="organisationDetail.applicationURL"></v-text-field>
              </v-flex>
              <v-flex xs3 mx-1>
                <v-select
                  :items="organisationTypes"
                  item-text="name"
                  item-value="id"
                  label="Organisation Type"
                  v-model="organisationDetail.organisationTypeId"
                ></v-select>
              </v-flex>
              <v-flex xs4 mx-1><v-switch v-model="organisationDetail.isPrimaryOrganisation" label="Primary Organisation"></v-switch></v-flex>
              <v-flex xs4 mx-1><v-select clerable v-model="organisationDetail.accountingSystem" :items="['Xero', 'SageOne']" label="Accounting System"></v-select></v-flex>
              <v-flex xs4 mx-1>
                <v-autocomplete v-if="organisationDetail&&organisationDetail.accountingSystem == 'SageOne'"
                ref="accountingCompanies" v-on:blur="$refs['accountingCompanies'].blur()"
                :items="accountingCompanies"
                clearable
                item-text="name"
                item-value="id"
                v-model="organisationDetail.accountingId"
                ></v-autocomplete>
                <v-autocomplete v-else-if="organisationDetail&&organisationDetail.accountingSystem == 'Xero'"
                ref="accountingCompanies" v-on:blur="$refs['accountingCompanies'].blur()"
                :items="accountingCompanies"
                clearable
                item-text="tenantName"
                item-value="id"
                v-model="organisationDetail.accountingId"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 mx-1>
                <v-checkbox v-model="organisationDetail.accountBasedAccounting" label="Account based accounting"></v-checkbox>
              </v-flex>
              
              <v-flex xs6>
                <v-textarea auto-grow label="Token" v-model="organisationDetail.token"></v-textarea>
                <v-btn
                  round
                  color="primary"
                  @click="generateOrganisationToken(organisationDetail)"
                >Generate Token</v-btn>
              </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs6>
                <v-layout justify-center wrap>
                  <v-flex xs8 mx-1>
                    <h3 class="grey--text">Glue Microservices</h3>
                  </v-flex>
                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap>
                      <v-flex xs4 mx-1>
                        <v-checkbox v-model="organisationDetail.zhoneIntegration" label="Zhone/ZMS"></v-checkbox>
                      </v-flex>
                      <v-flex xs6 mx-1>
                        <v-text-field mx-1 :disabled="!organisationDetail.zhoneIntegration" v-model="organisationDetail.networkAPI" label="Zhone Network API Endpoint"></v-text-field>
                      </v-flex>

                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap>
                      <v-flex xs4 mx-1>
                        <v-checkbox v-model="organisationDetail.u2000Integration" label="Huawei: U2000"></v-checkbox>
                      </v-flex>
                      <v-flex xs6 mx-1>
                        <v-text-field mx-1 v-model="organisationDetail.u2000NetworkApi" label="U2000 Endpoint"></v-text-field>
                      </v-flex>

                    </v-layout>
                  </v-flex>

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap>
                      <v-flex xs4 mx-1>
                        <v-checkbox v-model="organisationDetail.acsIntegration" label="Glue: ACS"></v-checkbox>
                      </v-flex>
                      <v-flex xs6 mx-1>
                       <v-text-field mx-1 v-model="organisationDetail.acsEndpoint" label="ACS Endpoint"></v-text-field>
                      </v-flex>

                    </v-layout>
                  </v-flex>

                  

                  <v-flex xs10 mx-1>
                    <v-layout justify-left align-center wrap>
                      <v-flex xs4 mx-1>
                        <v-checkbox v-model="organisationDetail.radiusIntegration" label="Glue: Radius Server"></v-checkbox>
                      </v-flex>
                      <v-flex xs6 mx-1>
                        <v-text-field mx-1 :disabled="!organisationDetail.radiusIntegration" v-model="organisationDetail.radiusEndpoint" label="Radius Endpoint"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </div>
    <div v-if="displayContents('modules')">
      <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="allModules"
        v-model="modules"
        item-key="id"
        align-center
        select-all
        style="cursor: pointer"
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs-center">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>-->
          <td>
            <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.name}}</td>
          <td
            @click="routerLinkToDetails(props.item)"
            class="text-xs-center"
          >{{props.item.description}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>

    <div v-if="displayContents('users')">
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn round color="primary" @click="attachContactModal=true">Add Contact to Organisation</v-btn>
      </v-toolbar>
      <v-data-table
      :headers="userHeaders"
      :items="organisationUsers"
      item-key="id"
      class="elevation-1"
      >
      <template v-slot:items="props">
        <td class="text-xs-center"><v-icon color="red" @click="removeContactFromOrg(props.item)">remove_circle</v-icon></td>
      <td class="text-xs-center">{{props.item.name}}</td>
      <td class="text-xs-center">{{props.item.surname}}</td>
      <td class="text-xs-center">{{props.item.idNumber}}</td>
      <td class="text-xs-center" ><v-select :items="contactTypes" item-value="id" item-text="name" @change="selectContactType(props.item)" v-model="props.item.contactType" ></v-select></td>
      <td class="text-xs-center">{{props.item.userType}}</td>
      </template>
      <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>
    </div>
    <!-- <v-dialog v-model="attachContactModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">ADD USER</h1>
        </v-toolbar>
        <v-card-text>
          <v-select
          v-model="contact.userType"
          :items="userTypes"
          label="User Type"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary white--text" @click="attachContactModal=false">Cancel</v-btn>
            <v-btn round color="primary white--text" @click="saveContact">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

     <v-dialog persistent v-model="attachContactModal" max-width="900px">
        <v-card>
          <v-toolbar flat color="primary">
            <h1 class="headline white--text">ADD CONTACT TO ORGANISATION</h1>
          </v-toolbar>
          <v-layout>
              <v-flex xs6 mx-3>
            <v-autocomplete
              clearable
              hide-no-data
              flat
              color="primary"
              v-model="contact.userType"
              :items="userTypes"
              item-text="name"
              item-value="id"
              label="*Select User Type"
              class="pt-4"
              persistent-hint
            ></v-autocomplete>
              </v-flex>
              <v-flex xs6 mx-3>
             <v-autocomplete
              clearable
              hide-no-data
              flat
              color="primary"
              v-model="contact.contactType"
              :items="contactTypes"
              item-text="name"
              item-value="id"
              label="*Select Contact Type"
              class="pt-4"
              persistent-hint
            ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-spacer></v-spacer>
            <v-text-field
              v-show="contact.userType&&contact.contactType"
              v-model="searchContacts"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              max-width="50px"
              class="pa-3"
            ></v-text-field>
            </v-layout>
        <v-data-table
          v-if="contact.userType&&contact.contactType"
          :search="searchContacts"
          :headers="contactHeaders"
          class="elevation-1"
          :rows-per-page-items="[10, 25, 50, 100]"
          :items="allContacts"
          item-key="id"
          align-center
        >
            <template v-slot:items="props">
              <td class="justify-center layout px-0">
                <v-icon
                  class="mr-2"
                  v-if="!organisationUsers.map(x=>x.contactId).includes(props.item.id)"
                  @click="addOrganisationContact(props.item)"
                  color="primary"
                >add_circle_outline</v-icon>
                <!-- <v-icon small @click="deleteItem(props.item.id)">delete</v-icon> -->
              </td>
              <td class="text-xs-center">{{props.item.name}}</td>
              <td class="text-xs-center">{{props.item.surname}}</td>
              <td class="text-xs-center">{{props.item.idNumber}}</td>
              <td class="text-xs-center">{{props.item.mobileNumber}}</td>
              <td class="text-xs-center">{{props.item.telephoneNumber}}</td>
              <td class="text-xs-center">{{props.item.emailAddress}}</td>
            </template>
            <template
              v-slot:pageText="props"
            >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
          </v-data-table>

          <v-card-actions class="justify-center layout px-0">
            <v-btn
              color="primary"
              round
              @click="attachContactModal=false"
            >Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      accountingCompanies: [],
      contactTypes:[],
      organisationDetail: null,
      modules: [],
      foreignKey: [],
      initialModules: [],
      userTypes:["systemUser", "organisationAdmin"],
      allModules: [],
      organisationTypes: [],
      organisationUsers: [],
      primaryColour: "#a6aba8",
      secondaryColour: '#a6aba8',
      activeTabName: "",
      attachContactModal: false,
      addContactModal: false,
      contact: {},
      contactUserType: null,
      contacts:[],
      organisationUserRoles: [],
      allContacts: null,
      searchContacts: '',
      tabs: [
        { name: "info", displayName: "Information" },
        { name: "modules", displayName: "Modules" },
        { name: "users", displayName: "Users" }
      ],
      userHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Surname",
          align: "center",
          value: "surname"
        },
        {
          text: "ID Number",
          align: "center",
          value: "idNumber"
        },
            {
          text: "Contact Type",
          align: "center",
          value: "contactType",
          width: "120px"
        },
        {
          text: "User Type",
          align: "center",
          value: "userType"
        }
      ],
      headers: [
        //         {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Description",
          align: "center",
          value: "description"
        }
      ],
      contactHeaders: [
        {
          text: "Actions",
          align: "center"
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Surname",
          align: "center",
          value: "surname"
        },
        {
          text: "ID Number",
          align: "center",
          value: "idNumber"
        },
        {
          text: "Mobile",
          align: "center",
          value: "mobileNumber"
        },
        {
          text: "Telephone",
          align: "center",
          value: "telephoneNumber"
        },
        {
          text: "Email",
          align: "center",
          value: "emailAddress"
        }
      ]
    };
  },
  watch: {
    'organisationDetail.accountingSystem': {
      immediate: true,
      handler(value){
        if(value == 'SageOne'){
          this.fetchSageCompanies()
        } else if(value == 'Xero'){
          this.getXeroOrganisations()
        }
      }
    }
  },

  created() {
    this.initialize();
    this.setActiveTabName("info");
  },
  async mounted() {
    this.setActiveTabName("info");
  },

  methods: {
    async fetchSageCompanies(){
      await Api().get('/sageOne/company').then(res=>{
        this.accountingCompanies = res.data.Results.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    getXeroOrganisations(){
      Api().get('/xero/admin/getOrganisations').then(response=>{
        console.log(response.data)
        this.accountingCompanies = response.data
        
      })
    },
     selectContactType(item){
 Api().put('/organisationContact/' + item.id,{
   contactTypeId: item.contactType
 })
    },
    fetchOrgUserRoles(){
      Api()
      .get('/userRole')
      .then(response=>{
        this.userRole=response.data
      })
    },
    changeActiveStatus(){
      this.organisationDetail.isActive = !this.organisationDetail.isActive
    Api()
      .put('/organisation/'+this.organisationDetail.id,{
        isActive: this.organisationDetail.isActive
      })
    },
    async addOrganisationContact(item){
      await Api()
      .post('/organisationContact/subOrganisation',{
        organisationId: this.$route.params.organisationId,
        contactId: item.id,
        contactTypeId: this.contact.contactType,
        userType: this.contact.userType,
        isActive: true,
        isDeleted: false
      }).then(response=>{
        if(this.contact.userType==='organisationAdmin'){
            for(let i=0; i<this.organisationUserRoles.length;i++){
            if(this.organisationUserRoles[i].isAdmin){
              Api()
              .post('/userRoleContact/subOrganisation',{
                contactId: item.id,
                userRoleId: this.organisationUserRoles[i].id,
                organisationId: this.$route.params.organisationId,
                isActive: true,
                isDeleted: false
              })
            }
        }
        }
        this.fetchOrganisationInfo()
        this.attachContactModal=false
        this.contact = {};
      })
    },
    fetchModules() {
      Api()
        .get("/modules")
        .then(response => {
          this.allModules = response.data;
        });
    },
    fetchAllContacts(){
      Api()
      .get('/contacts/all')
      .then(response=>{
        this.allContacts=response.data
        // console.log(this.allContacts)
      })
    },
    fetchOrganisationInfo() {
      this.modules = [];
      this.initialModules = [];
      this.foreignKey = [];
      this.organisationUsers=[]
      Api()
        .get("/organisation/" + this.$route.params.organisationId)
        .then(response => {
          console.log(response.data)
          this.organisationDetail = response.data;
          for(let y =0; y< this.organisationDetail.organisationContacts.length;y++){
            if(this.organisationDetail.organisationContacts[y].isActive&&!this.organisationDetail.organisationContacts[y].isDeleted){
              this.organisationUsers.push({
                id: this.organisationDetail.organisationContacts[y].id,
              contactId:this.organisationDetail.organisationContacts[y].contactId,
              name:this.organisationDetail.organisationContacts[y].contact.name,
              surname:this.organisationDetail.organisationContacts[y].contact.surname,
              idNumber:this.organisationDetail.organisationContacts[y].contact.idNumber,
              userType:this.organisationDetail.organisationContacts[y].userType,
              contactType:this.organisationDetail.organisationContacts[y].contactTypeId
              })
            }
          }
          // this.organisationUsers=response.data.organisationContacts
          // console.log('Org Users', this.organisationUsers)
          let organisationModules = response.data.organisationModules;
          for (let i = 0; i < organisationModules.length; i++) {
            if (!organisationModules[i].isDeleted) {
              this.modules.push(organisationModules[i].module);
              this.initialModules.push(organisationModules[i].module);
              this.foreignKey.push({
                id: organisationModules[i].id,
                moduleId: organisationModules[i].module.id
              });
            }
          }
        });
    },
    getOrgTypes() {
      Api()
        .get("/organisationType")
        .then(response => {
          this.organisationTypes = response.data;
        });
    },
    saveInfoChanges() {
      Api().put("/organisation/"+this.$route.params.organisationId, {
        name: this.organisationDetail.name,
        description: this.organisationDetail.description,
        organisationTypeId: this.organisationDetail.organisationTypeId,
        token: this.organisationDetail.token,
        logo: this.organisationDetail.logo,
        isPrimaryOrganisation: this.organisationDetail.isPrimaryOrganisation,
        primaryColour: this.primaryColour.hex,
        secondaryColour: this.secondaryColour.hex,
        oneDevicePolicy: this.organisationDetail.oneDevicePolicy,
        zhoneIntegration: this.organisationDetail.zhoneIntegration,
        zmsIpAddress: this.organisationDetail.zmsIpAddress,
        zmsUsername: this.organisationDetail.zmsUsername,
        zmsPassword: this.organisationDetail.zmsPassword,
        acsIntegration: this.organisationDetail.acsIntegration,
        acsEndpoint: this.organisationDetail.acsEndpoint,
        acsIntegrationKey: this.organisationDetail.acsIntegrationKey,
        apiDocumentationLink: this.organisationDetail.apiDocumentationLink,
        networkAPI: this.organisationDetail.networkAPI,
        u2000NetworkApi: this.organisationDetail.u2000NetworkApi,
        u2000Integration: this.organisationDetail.u2000Integration,
        radiusIntegration: this.organisationDetail.radiusIntegration,
        radiusEndpoint: this.organisationDetail.radiusEndpoint,
        accountingSystem: this.organisationDetail.accountingSystem,
        accountingId: this.organisationDetail.accountingId,
        accountBasedAccounting: this.organisationDetail.accountBasedAccounting
      });
    },
    fetchUserRoles(){
      Api()
      .get('/userRole/byOrg/'+this.$route.params.organisationId)
      .then(response=>{
        this.organisationUserRoles=response.data
      })
    },
    async saveModuleChanges() {
      for (let i = 0; i < this.modules.length; i++) {
        if (this.initialModules.indexOf(this.modules[i]) === -1) {
          await Api().post("/organisationModule", {
            moduleId: this.modules[i].id,
            organisationId: this.$route.params.organisationId,
            isActive: true,
            isDeleted: false
          }).then(async response=>{
            
            for (let x=0;x<this.modules[i].moduleSubmodules.length;x++){
              if(this.modules[i].moduleSubmodules[x].isActive&&!this.modules[i].moduleSubmodules[x].isDeleted&&
              // this.modules[i].moduleSubmodules[x].module.isActive&&!this.modules[i].moduleSubmodules[x].module.isDeleted&&
              this.modules[i].moduleSubmodules[x].submodule.isActive&&!this.modules[i].moduleSubmodules[x].submodule.isDeleted){
                // Organisation User Roles - add permissions
                for(let c=0;c<this.organisationUserRoles.length;c++){
                  if(this.organisationUserRoles[c].isAdmin){
                    Api()
                  .post('/routePermission',{
                    moduleSubmoduleId: this.modules[i].moduleSubmodules[x].id,
                    userRoleId: this.organisationUserRoles[c].id,
                    create: true,
                    read: true,
                    update: true,
                    delete: true,
                    admin: true,
                    organisationId: this.$route.params.organisationId,
                    isActive: true,
                    isDeleted: false
                  })
                  
                  } else {
                    Api()
                  .post('/routePermission',{
                    moduleSubmoduleId: this.modules[i].moduleSubmodules[x].id,
                    userRoleId: this.organisationUserRoles[c].id,
                    create: false,
                    read: false,
                    update: false,
                    delete: false,
                    admin: false,
                    organisationId: this.$route.params.organisationId,
                    isActive: true,
                    isDeleted: false
                  })
                  
                  }
                }
              }
            }
          });
        }
      }
      for (let x = 0; x < this.initialModules.length; x++) {
        if (this.modules.indexOf(this.initialModules[x]) === -1) {
          let moduleId = this.initialModules[x].id;
          console.log(this.foreignKey)
          let foreignKeyId = this.foreignKey.find(x=>x.moduleId===moduleId);
          
          await Api().put("/organisationModule/" + foreignKeyId.id, {
            isActive: false,
            isDeleted: true
          });
          await Api().get('/modules/'+moduleId).then(response=>{
              let subs = response.data.moduleSubmodules
              for (let a =0; a<response.data.moduleSubmodules.length;a++){
                try {
                  Api()
              .get('/routePermission/modulesubmodule/'+response.data.moduleSubmodules[a].id+'/'+this.$route.params.organisationId,{
                orgToken: this.organisationDetail.token
              }).then(result=>{
                
                for (let b=0;b<result.data.length;b++){
                  Api()
                  .put('/routePermission/'+result.data[b].id,{
                    isActive: false,
                    isDeleted: true
                  })
                  
                }
              })
                } catch {
                  console.log('Error with moduleSubmoduleId: '+  response.data.moduleSubmodules[a].id)
                }
                
              }
          })
        }
      }
      this.fetchOrganisationInfo();
    },

    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
     async fetchContactTypes() {

       if(this.$store.state.currentOrg.org.isPrimaryOrganisation==true){
       Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data
        });
      }  else{
           Api()
        .get("/contactTypes/activeIsp")
        .then(response => {
          this.contactTypes = response.data
        });
        }
    
    },
    initialize() {
      this.fetchUserRoles();
      this.getOrgTypes();
      this.fetchModules();
      this.fetchOrganisationInfo();
      this.fetchAllContacts();
      this.fetchOrgUserRoles()
      this.fetchContactTypes()
    },
    routerLinkToDetails(item) {
      this.$router.push({ path: "/modules/" + item.id });
    },
    generateOrganisationToken(item){
      Api()
      .post('/orgToken',{
        id: item.id,
        name: item.name,
        description: item.description
      })
      .then(response=>{
        this.organisationDetail.token=response.data.token
        Api()
        .put('/organisation/'+item.id,{
          token: this.organisationDetail.token
        })
      })
    },
    saveContact(){

    },
    removeContactFromOrg(item){
      confirm("Are you sure you would like to remove this contact from the organisation?")&&
      Api()
      .put('/organisationContact/'+item.id,{
        isActive: false,
        isDeleted: true
      })
      .then(response=>{
        this.fetchOrganisationInfo()
      })
    }
  }
};
</script>
<style>
.Planned {
  border-left: solid #d61212;
}
.Ongoing {
  border-left: 4px solid #eb780c;
}
.Complete {
  border-left: 4px solid #5eb110;
}
.Live {
  border-left: 4px solid #5eb110;
}
</style>
